import {
    STORE_INVESTOR_TRACKER,
    STORE_LOCATION,
    REMOVE_LOCATION,
    STORE_PERSON,
    REMOVE_PERSON,
} from '../../constants/investorTracker';

const initialState = {
    companies: [],
    people: [],
    locations: [],
    currentPersonId: null,
};

const upsert = (list, item, key = 'id') => {
    const idx = list.findIndex((l) => l[key] === item[key]);
    if (idx === -1) return [...list, item];
    const next = list.slice();
    next[idx] = item;
    return next;
};

export default (state = initialState, action) => {
    switch (action.type) {
        case STORE_INVESTOR_TRACKER:
            return {
                ...state,
                companies: action.payload?.companies || [],
                people: action.payload?.people || [],
                locations: action.payload?.locations || [],
                currentPersonId: action.payload?.currentPersonId || state.currentPersonId,
            };

        case STORE_LOCATION:
            return {
                ...state,
                locations: upsert(state.locations, action.location, 'id'),
            };

        case REMOVE_LOCATION:
            return {
                ...state,
                locations: state.locations.filter((l) => l.id !== action.locationId),
            };

        case STORE_PERSON:
            return {
                ...state,
                people: upsert(state.people, action.person, 'id'),
            };

        case REMOVE_PERSON:
            return {
                ...state,
                people: state.people.filter((p) => p.id !== action.personId),
            };

        default:
            return state;
    }
};
